<template>
  <div class="divideGroupsDialog">
    <el-form :model="GroupForm" :rules="rules" ref="GroupForm">
      <el-form-item label="分组名称：" prop="groupName">
        <el-input
          v-model.trim="GroupForm.groupName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel('GroupForm')">取 消</el-button>
      <el-button type="primary" @click="onSubmit('GroupForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { groupAdd, groupUpdate } from "@/services/examManager.js";

export default {
  name: "",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    groupId: {
      type: Number,
    },
  },
  data() {
    // 校验非空
    var validateIsNull = (rule, value, callback, prefixMsg) => {
      if (value instanceof Array) {
        value = value.join("");
      }
      if (value.split(" ").join("").length === 0) {
        callback(new Error(prefixMsg + "不能为空"));
      } else {
        callback();
      }
    };
    return {
      GroupForm: {
        groupName: "",
      },
      rules: {
        groupName: [
          { required: true, message: "请输入分组名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "分组名称");
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 取消
    onCancel(formName) {
      // 设置取消状态，让父组件处理
      this.$emit("cancel");
      this.$refs[formName].resetFields();
      this.GroupForm = {};
    },
    // 确定
    onSubmit(formName) {
      // 编辑状态
      if (this.isEdit === true) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.updateGroupData();
          } else {
            return false;
          }
        });
      } else {
        // 新增状态
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addGroupName();
          } else {
            return false;
          }
        });
      }
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 添加分组
    async addGroupName() {
      const addGroupName = {};
      this.UtilFun(addGroupName);
      addGroupName.groupName = this.GroupForm.groupName;
      console.log(addGroupName, "添加分组请求参数");
      const { data } = await groupAdd(addGroupName);
      console.log(data, "添加分组返回数据");
      if (data.Status === 200) {
        // 发送消息
        this.$emit("success");
        // 设置成功提示
        this.$message.success("添加成功");
        // 清除表单内容
        this.GroupForm = {};
      } else {
        this.$message.error(data.Data);
      }
    },

    // 修改组
    async updateGroupData() {
      const groupPara = {};
      this.UtilFun(groupPara);
      groupPara.groupID = this.$parent.$parent.editMemberData[1];
      groupPara.groupName = this.GroupForm.groupName;
      console.log(groupPara);
      const { data } = await groupUpdate(groupPara);
      console.log(data);
      if (data.Status === 200) {
        // 发送消息
        this.$emit("success");
        this.$message.success("修改组成功");
        this.GroupForm = {};
      } else {
        this.$message.error(data.Msg);
      }
    },
  },
  created() {
    this.GroupForm.groupName = this.$parent.$parent.editMemberData[0];
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
  margin-top: 30px;
  .el-button {
    margin-right: 30px;
    &:nth-child(1) {
      background: #eeeeee;
      opacity: 1;
      border-radius: 4px;
    }
    &:nth-child(2) {
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
    }
  }
}

::v-deep .el-form-item__error {
  margin-left: 118px;
}

.divideGroupsDialog {
  ::v-deep .el-form {
    display: flex;
  }
  ::v-deep .el-form-item {
    display: flex;
  }
  ::v-deep .el-form-item__label {
    line-height: 2.5 !important;
  }
}
</style>